import getDateFormat from './getDateFormat';

export default getDateFormat;
